import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from '../components/CtaButton';
import { CountdownTimer } from '../components/CountdownTimer';
import { ScarcityBar } from '../components/ScarcityBar';
const includes = ['6 Clinical Volumes', '5 Exclusive Bonuses', 'Visual Decision Frameworks', 'Clinical Checklists', 'Practical Protocols', 'Lifetime Digital Access'];
export function FinalCta() {
  return <section className="w-full bg-navy-950 py-14 sm:py-20" aria-labelledby="final-heading" data-id="element-166" data-mp="34gaajvzv6xo8">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-167" data-mp="30imayfn88gq0">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-300" data-id="element-168" data-mp="3e8g4vcdl9r6l">
          Your next case is waiting
        </p>
        <h2 id="final-heading" className="mx-auto mt-3 max-w-xl text-center font-display text-[28px] font-black leading-[1.1] tracking-tight text-white sm:text-[42px]" data-id="element-169" data-mp="39fd8kwhfg3mp">
          Stop guessing. Start planning with a system.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-brand-100 sm:text-lg" data-id="element-170" data-mp="ppzqzfq195zr">
          Every case still requires decisions. The question is whether you’ll approach them with
          more uncertainty — or with a structured clinical process you can return to every time.
        </p>

        <ul className="mx-auto mt-8 grid max-w-xl gap-2.5 sm:grid-cols-2" data-id="element-171" data-mp="14evt6w5erosg">
          {includes.map(item => <li key={item} className="flex items-center gap-2.5 rounded-xl border border-white/10 bg-white/[0.05] px-3.5 py-3" data-id="element-172" data-mp="6u9m9kqptvi6">
              <CheckIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-emerald-400" data-id="element-173" data-mp="gojff4nhexty" />
              <span className="text-[13.5px] font-semibold leading-snug text-white" data-id="element-174" data-mp="kshddc12m2lf">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="mt-9 text-center font-display text-[13px] font-bold uppercase tracking-[0.18em] text-brand-300" data-id="element-175" data-mp="1w6bpjhwropvv">
          Today
        </p>
        <p className="text-center font-display text-[64px] font-black leading-none text-white sm:text-[80px]" data-id="element-176" data-mp="3t5o3nme54nn0">
          $27
        </p>
        <p className="mt-2 text-center text-[12.5px] font-semibold text-brand-100" data-id="element-177" data-mp="62jbl5nmns5u">
          One-time payment • Instant access • 7-day guarantee
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-178" data-mp="14hrqiidnotb">
          <CtaButton label="Yes — I want to plan with confidence" sub="Get instant access to The Aligner Planning Master System™" size="lg" data-id="element-179" data-mp="39j058zr37wkb" />
        </div>

        <div className="mt-5" data-id="element-180" data-mp="3j9uu8bvpxa9g">
          <CountdownTimer tone="dark" data-id="element-181" data-mp="3ja33ltsmtxfw" />
        </div>

        <div className="mt-6" data-id="element-182" data-mp="3eiuxb6mlms6y">
          <ScarcityBar tone="dark" spotsLeft={9} data-id="element-183" data-mp="3ehjr705ol8co" />
        </div>

        <p className="mx-auto mt-6 flex max-w-sm items-start justify-center gap-2 text-center" data-id="element-184" data-mp="2qsqswx1l6oew">
          <GlobeIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-300" data-id="element-185" data-mp="2lu766uf658lh" />
          <span className="text-[12.5px] leading-snug text-brand-100" data-id="element-186" data-mp="11bwpd8h5bumy">
            Currency conversion is automatic — you pay in your local currency.
          </span>
        </p>
      </div>
    </section>;
}